import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export default class AdminStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'AdminStore',
			properties: [
				'businessEmail',
				'token',
				'loggedIn',
				'businessId',
				'adminUserId',
				'adminUser',
				'adminBusiness',
				'selectedProduct',
				'selectedOrder',
			],
		});
	}

	businessEmail = '';
	token = '';
	loggedIn = false;
	businessId = '';
	adminUserId = '';
	adminUser = {};
	adminBusiness = {};
	selectedProduct = {};
	selectedOrder = {};

	reset = () => {
		this.businessEmail = '';
		this.token = '';
		this.loggedIn = false;
		this.businessId = '';
		this.adminUserId = '';
		this.adminUser = {};
		this.adminBusiness = {};
		this.selectedProduct = {};
		this.selectedOrder = {};
	};

	setBusinessEmail = async state => {
		runInAction(async () => {
			this.businessEmail = state;
		});
	};

	setToken = async state => {
		runInAction(async () => {
			this.token = state;
		});
	};

	setLoggedIn = async state => {
		runInAction(async () => {
			this.loggedIn = state;
		});
	};

	setBusinessId = async state => {
		runInAction(async () => {
			this.businessId = state;
		});
	};

	setAdminUserId = async state => {
		runInAction(async () => {
			this.adminUserId = state;
		});
	};

	setAdminUser = async state => {
		runInAction(async () => {
			this.adminUser = state;
		});
	};

	setAdminBusiness = async state => {
		runInAction(async () => {
			this.adminBusiness = state;
		});
	};

	setSelectedProduct = async state => {
		runInAction(async () => {
			this.selectedProduct = state;
		});
	};

	setSelectedOrder = async state => {
		runInAction(async () => {
			this.selectedOrder = state;
		});
	};
}
